var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KeyUnlockDeclinedError, } from "@hyper-hyper-space/hhs3_rdb_runtime";
import { keyPassphraseRequiredFromError, LanguageError, runLanguageText, } from "./adapter.js";
import { formatDiagnostics } from "./format/diagnostics.js";
import { renderStatementOutput } from "./format/table.js";
import { fulfillPassphraseNeed, runMetaCommand } from "./meta.js";
export function runLanguageWithUnlock(session, text, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        while (true) {
            try {
                return yield runLanguageText(session, text, options === null || options === void 0 ? void 0 : options.auth);
            }
            catch (error) {
                const required = keyPassphraseRequiredFromError(error);
                if (required === undefined)
                    throw error;
                const need = { kind: 'statement-unlock', label: required.label };
                const passphrase = yield ((_a = options === null || options === void 0 ? void 0 : options.requestPassphrase) === null || _a === void 0 ? void 0 : _a.call(options, need));
                if (passphrase === undefined)
                    return need;
                yield session.unlockKey(required.label, passphrase);
            }
        }
    });
}
export function runCommand(session, command, file, options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            const meta = yield runMetaCommand(session, command);
            if (meta.handled) {
                if (meta.needsPassphrase !== undefined) {
                    const passphrase = yield ((_a = options === null || options === void 0 ? void 0 : options.requestPassphrase) === null || _a === void 0 ? void 0 : _a.call(options, meta.needsPassphrase));
                    if (passphrase === undefined) {
                        return { exitCode: 1, output: 'passphrase required', needsPassphrase: meta.needsPassphrase };
                    }
                    return { exitCode: 0, output: yield fulfillPassphraseNeed(session, meta.needsPassphrase, passphrase) };
                }
                return { exitCode: 0, output: (_b = meta.output) !== null && _b !== void 0 ? _b : '', quit: meta.quit };
            }
            const run = yield runLanguageWithUnlock(session, command, options);
            if (!('results' in run)) {
                return { exitCode: 1, output: 'passphrase required', needsPassphrase: run };
            }
            return {
                exitCode: 0,
                output: run.results
                    .map((item) => renderStatementOutput(session, item))
                    .filter(Boolean)
                    .join('\n'),
            };
        }
        catch (error) {
            if (error instanceof KeyUnlockDeclinedError)
                return { exitCode: 1, output: 'unlock declined' };
            if (error instanceof LanguageError) {
                return { exitCode: 2, output: formatDiagnostics(error.diagnostics, file, error.hints) };
            }
            return { exitCode: 1, output: error instanceof Error ? error.message : String(error) };
        }
    });
}
